import { render, staticRenderFns } from "./WebsiteScreen.vue?vue&type=template&id=f00aecfc&"
import script from "./WebsiteScreen.vue?vue&type=script&lang=js&"
export * from "./WebsiteScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports